import { fetchInventoryFromOutlet } from "./fetch-inventory-from-outlet";
import { snoozeItemFromOutlet } from "./snooze-item-from-outlet";
import { unsnoozeItemFromOutlet } from "./unsnooze-item-from-outlet";

export const inventoryRepo = {
  get: fetchInventoryFromOutlet,
  snoozeItem: snoozeItemFromOutlet,
  unsnoozeItem: unsnoozeItemFromOutlet,
};
